import React from "react";
import {connect} from 'react-redux'
import { withRouter } from 'react-router-dom'
import CircularProgress from 'material-ui/CircularProgress';

export class Settings extends React.Component {
  constructor(props){
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    
  }

  render() {
    if (this.props.loading) {
      return  <div style={{textAlign: 'center'}}><CircularProgress/></div>;
    }


    return (
     <div>
       Settings
      </div>);
  }
}

let mapStateToProps = ({websiteEndpoint},{match}) => ({
  loading: websiteEndpoint.fetchInProgress,
  error: websiteEndpoint.fetchError? true:false
})

let mapDispatchToProps = (dispatch) => ({
  
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(Settings));





// WEBPACK FOOTER //
// ./src/containers/Settings.js